'use client';
import ProfileAvatarDropdown from '@/app/(dashboard)/dashboard/[organizationId]/_components/ProfileAvatarDropdown';
import styles from '@/app/(new)/_components/Header/Header.module.css';
import logo from '@/app/(new)/_components/Header/img.png';
import type { CurrentUser } from '@/interfaces/currentUser.interface';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { SignedIn, SignedOut, UserButton } from '@clerk/nextjs';

export function MobileHeader() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div className={styles.mobileHeaderSpacer} />
      <header className={styles.mobileHeader} data-open={isOpen}>
        <div className={styles.mobileMenu}>
          <Link href={'/'}>
            <Image src={logo} alt={'logo'} width={56} height={56} />
          </Link>
          <button className={styles.mobileMenuButton} onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="#344054"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 12H21M3 6H21M3 18H21"
                  stroke="#344054"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </button>
        </div>
        <div className={styles.mobileMenuContent}>
          <nav>
            <ul>
              <li>
                <Link href="/projects">Projects</Link>
              </li>
              <li>
                <Link href="/opportunities">Opportunities</Link>
              </li>
              <li>
                <Link href="/organizations">Organisations</Link>
              </li>
            </ul>
          </nav>
          <div className={styles.actionButtons}>
            <SignedIn>
              <UserButton />
            </SignedIn>
            <SignedOut>
              <Link href={'/sign-in'} className={styles.loginButton}>
                Log in
              </Link>
              <Link href={'/sign-up'} className={styles.signUpButton}>
                Sign up
              </Link>
            </SignedOut>
          </div>
        </div>
      </header>
    </>
  );
}
